import * as commonStateAction from '../../actions/commonStateAction';
import commonStore from '../../store/commonStore.js';
import $ from 'jquery';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';

export const switchPage = (pageName: string, filterName?: string, filterValue?: string, authorSoeId?: string | number, event?: any) => {
    const _switchPageData: any = {
        pageName: null,
        filterName: null,
        filterValue: null,
        authorSoeId: null,
    };

    switch (pageName) {
        case 'backToMainPage':
        case 'TocToMainPage':
            _switchPageData.pageName = 'mainPage';
            break;
        case 'focusListPage':
            if (window.HTML_RENDITION.initialData.isStaticHtml){
                return;
            }
            _switchPageData.pageName = 'focusListPage';
            break;
        case 'privacyPolicyPage':
            if (filterName === 'moreTab'){
                RSCH_HTML_TRACKING_CONFIG.trackShareTabPrivacyPolicyClick();
            } else {
                RSCH_HTML_TRACKING_CONFIG.trackPrivacyPolicyFooterClick();
            }
            _switchPageData.pageName = 'privacyPolicyPage';
            break;
        case 'cookiesPolicyPage':
            if (filterName === 'moreTab'){
                RSCH_HTML_TRACKING_CONFIG.trackShareTabCookiePolicyClick();
            } else {
                RSCH_HTML_TRACKING_CONFIG.trackCookiePolicyFooterClick();
            }
            _switchPageData.pageName = 'cookiesPolicyPage';
            break;
        case 'termsAndConditions':
            RSCH_HTML_TRACKING_CONFIG.trackTermsAndConditionsFooterClick();
            _switchPageData.pageName = 'termsAndConditions';
            break;
        case 'supplyChainCompanyListPage':
            _switchPageData.pageName = 'supplyChainCompanyListPage';
            break;
        case 'reportingCalendarPage':
            RSCH_HTML_TRACKING_CONFIG.trackCorporateCalendar();
            _switchPageData.pageName = 'reportingCalendarPage';
            break;
        case 'labelsPage':
            RSCH_HTML_TRACKING_CONFIG.trackLabelslinksleftmenuClick(filterName);
            _switchPageData.pageName = pageName;
            _switchPageData.filterName = filterName;
            _switchPageData.filterValue = filterValue;
            break;
        default:
            _switchPageData.pageName = pageName;
            _switchPageData.filterName = filterName;
            _switchPageData.filterValue = filterValue;
            _switchPageData.authorSoeId = authorSoeId;
            break;
    }

    // Impotant!!! Don't change below code!!
    // Don't use redux in react to set mainPage and leftMenuPage status! Because it will cause Pages and all childrens component reRender! will cause performance issuse,special in IE!
    if (pageName == "backToMainPage" || pageName == "TocToMainPage") {
        // Impotant!!! Don't change below code sequence otherwise the scroll can't return right position
        $('#mainPage').show().prop({'hidden': false, 'role': 'main'});
        $('#innerPagePart').hide().prop({'hidden': true, 'role': 'complementary'});
        $('#leftMenuCitiBackTabLi').hide();
        // set mainPage scroll
        pageName == "backToMainPage" && $(window).scrollTop(window.HTML_RENDITION.windowScrollTop);
    } else {
        // Impotant!!! Don't change below code sequence otherwise the scroll can't return right position
        // record mainPage position
        window.HTML_RENDITION.windowScrollTop = $(window).scrollTop();
        $('#mainPage').hide().prop({'hidden': true, 'role': 'complementary'});
        $('#innerPagePart').show().prop({'hidden': false, 'role': 'main'});
        $('#leftMenuCitiBackTabLi').show();
        // set innerPage scroll
        $(window).scrollTop(0);
        commonStore.dispatch(commonStateAction.menuPaneStatus(''));
    }
    commonStore.dispatch(commonStateAction.changeSwitchPageData(_switchPageData));
};
